import type { TemplateSlot } from "../utils/derive-template";
import { ScheduleSlotCard } from "./ScheduleSlotCard";

interface SchedulePeriodicSectionProps {
  readonly title: string;
  readonly slots: readonly TemplateSlot[];
  readonly onEditSlot: (slot: TemplateSlot) => void;
  readonly onAddSlot?: () => void;
  readonly onContextMenu?: (slot: TemplateSlot, anchorRect: DOMRect) => void;
}

export function SchedulePeriodicSection({
  title,
  slots,
  onEditSlot,
  onAddSlot,
  onContextMenu,
}: SchedulePeriodicSectionProps) {
  if (slots.length === 0) return null;

  return (
    <section>
      <div className="flex items-center gap-2 mb-2">
        <h2 className="text-sm font-semibold text-ink">
          {title}
          {slots.length > 0 && (
            <span className="ml-2 text-xs font-normal text-ink-muted">
              ({slots.length})
            </span>
          )}
        </h2>
        {onAddSlot && (
          <button
            type="button"
            onClick={onAddSlot}
            className="w-5 h-5 flex items-center justify-center rounded text-xs text-ink-muted hover:text-ink hover:bg-surface-alt transition-colors"
          >
            +
          </button>
        )}
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-1.5">
        {slots.map((slot) => (
          <ScheduleSlotCard
            key={slot.eventId}
            slot={slot}
            onEdit={onEditSlot}
            onContextMenu={onContextMenu}
          />
        ))}
      </div>
    </section>
  );
}
